module.exports = __webpack_public_path__ + "static/img/aside-fixed-icons.92d8a22d.png";